import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppStore } from "@hooks/useAppStore";
import { Loader, ScrollContainer, useAppTheme } from "@memorang/ui";
import { useQuery } from "@tanstack/react-query";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import { useState } from "react";
import { View } from "react-native";
import { Card, List } from "react-native-paper";
import { getFaqs, getFormattedLanguage } from "../helpers";
import type { Faq } from "../types";

const FaqItem = ({ faq }: { faq: Faq }) => {
	const theme = useAppTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<Card
			mode="outlined"
			style={{ borderRadius: theme.roundness, marginBottom: 8 }}
		>
			<List.Accordion
				left={(props) => <Icon {...props} name={faq.icon} size={16} />}
				titleNumberOfLines={2}
				title={faq.question}
				expanded={expanded}
				onPress={() => setExpanded(!expanded)}
				style={{
					paddingVertical: 0,
					paddingHorizontal: 8,
					backgroundColor: expanded
						? theme.colors.elevation.level2
						: theme.colors.surface,
				}}
			>
				<List.Item
					title={() => <CustomMarkdownRenderer text={faq.answer} />}
					titleNumberOfLines={8}
				/>
			</List.Accordion>
		</Card>
	);
};

const FaqsContainer = () => {
	const { projectName } = useAppStore((store) => ({
		projectName: store.tenant.name,
	}));

	const { data: faqs, isLoading } = useQuery({
		queryKey: ["faqs", projectName],
		queryFn: () => getFaqs(projectName, getFormattedLanguage()),
		refetchOnWindowFocus: "always",
	});

	if (isLoading) {
		return (
			<View
				style={{
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
				}}
			>
				<Loader />
			</View>
		);
	}

	return (
		<ScrollContainer>
			{faqs?.map((faq) => (
				<FaqItem key={faq.question} faq={faq} />
			))}
		</ScrollContainer>
	);
};

export default FaqsContainer;
